import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '@env/environment';
import { IBusinessCard } from '@interfaces';
import { BusinessCardService } from '@services';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  constructor(
    private businessCardService: BusinessCardService,
    private activatedRoute: ActivatedRoute,
    private route: Router,
  ) {}
  isLoading: boolean = true;
  ngOnInit() {
    const nanoid = this.activatedRoute.snapshot.paramMap.get('nanoid') || '';
    if (nanoid) this.getBusinessCardDetails(nanoid);
  }
  businessCardData!: IBusinessCard;
  getBusinessCardDetails(nanoid: string) {
    this.businessCardService.getOriginalUrl(nanoid).subscribe({
      next: (res) => {
        if (res.status) {
          this.businessCardData = res.data;
          this.businessCardService.setBusinessCardDetails(res.data);
        }
      },
      error: (err) => {
        this.route.navigate(['/error/404']);
      },
      complete: () => {
        this.isLoading = false;
      },
    });
  }
}
